import React from 'react';
import { Button, Row, Col, Tooltip } from 'antd';
import { EyeOutlined, StopOutlined } from '@ant-design/icons';
import { CustomTable, GeneralContainer } from '../../../../components';
import { ShareResponse } from '../../../../share';
import SearchRow from '../components/Filters';
import { RefundsResponse } from '../../types/refunds-response';
import CustomAlert from '../../../../components/CustomAlert/CustomAlert';

interface RefundsViewProps {
  data?: RefundsResponse;
  onViewCreate: () => void;
  onPagination: (page: number, pageSize: number) => void;
  onViewDetail: (id: string) => void;
  formik: any;
  states?: ShareResponse[];
  isLoading: boolean;
  onResetFilters: () => void;
  handleModalConfirm: (opc: any) => void;
}

const RefundsView: React.FC<RefundsViewProps> = ({
  data,
  onViewCreate,
  onViewDetail,
  onPagination,
  formik,
  states,
  isLoading,
  onResetFilters,
  handleModalConfirm,
}) => {
  const columns = [
    {
      title: 'Número ticket',
      dataIndex: 'ticket',
      key: 'ticket',
      sorter: true,
      align: 'center',
    },
    {
      title: 'Tipo ticket',
      dataIndex: 'ticket_type',
      key: 'ticket_type',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Fecha de solicitud',
      dataIndex: 'query_date',
      key: 'query_date',
      sorter: true,
      align: 'center',
    },
    {
      title: 'Estado solicitud',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      align: 'center',
      render: (status: string) => {
        return <CustomAlert status={status} />
      },
    },
    {
      title: 'Solicitante',
      dataIndex: 'requester',
      key: 'requester',
      sorter: true,
      align: 'center',
      render: (_: any, item: any) =>
        `${item?.requester_document} - ${item?.requester}`,
    },
    {
      title: 'Regional',
      dataIndex: 'regional',
      key: 'regional',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Seccional',
      dataIndex: 'sectional',
      key: 'sectional',
      sorter: true,
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Observaciones',
      dataIndex: 'observations',
      key: 'observations',
      align: 'center',
      width: 300,
      render: (text: string) => (
        <Tooltip title={text || 'Sin registro'}>
          <div
            style={{
              maxWidth: 250,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              margin: '0 auto',
            }}
          >
            {text || 'Sin registro'}
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      align: 'center',
      render: (_: any, record: { id: number; status: string }) => {
        return (
          <>
            <Tooltip title="Ver solicitud">
              <Button
                type="link"
                icon={<EyeOutlined />}
                onClick={() => onViewDetail(record.id.toString())}
              />
            </Tooltip>
            {record.status.toLowerCase() === 'por aprobar' && (
              <Tooltip title="Anular solicitud">
                <Button
                  type="link"
                  icon={<StopOutlined />}
                  onClick={() => {
                    handleModalConfirm(record.id);
                  }}
                />
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  return (
    <GeneralContainer
      title="Solicitud de reintegros"
      actionLabel="Crear solicitud"
      onActionClick={onViewCreate}
      isLoading={isLoading}
    >
      {/* Filtros */}
      <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
        <Col xs={24}>
          <SearchRow
            formik={formik}
            states={states}
            onCancel={onResetFilters}
            isLoading={isLoading}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          <CustomTable
            loading={isLoading}
            columns={columns as any}
            dataSource={data?.data?.map((refund) => ({
              ...refund,
              id: Number(refund.id) || -1,
            }))}
            paginationConfig={{
              current: data?.current_page,
              pageSize: data?.per_page,
              total: data?.total,
              onChange: onPagination,
            }}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>
    </GeneralContainer>
  );
};

export default RefundsView;
